module.exports = __webpack_public_path__ + "static/media/comentarios_hp_02.8755b3cd.jpg";